import Component from 'antd/es/divider';
import 'antd/lib/divider/style';
export default Component;
